import config from "config/config"
import axios from "axios"

import * as url from "../helpers/url_helper"

export const studentMarkEntries = {
  getMarkEntries: async data => {
    const { page = 1, search = "", ...bodyData } = data || {}
    const params = new URLSearchParams({ page })
    if (search.trim()) params.append("search", search.trim())
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Get_Mark_Entries}?${params.toString()}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { ...bodyData, search: search.trim() },
    }
    return await axios(axiosConfig)
  },

  exportMarkReport: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Export_Mark_Report}`,
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
      data,
    }
    return await axios(axiosConfig)
  },

  getMarkEntryStudents: async data => {
    const { page = 1, search = "", ...bodyData } = data
    const params = new URLSearchParams({ page })
    if (search.trim()) params.append("search", search.trim())
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Get_Mark_Entry_Students}?${params.toString()}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { ...bodyData, search: search.trim() },
    }
    return await axios(axiosConfig)
  },

  saveMarkEntry: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Save_Mark_Entry}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },

  updateSubjectMarksConfig: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Subject_Marks_Config}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },
}
